module.exports = __webpack_public_path__ + "img/d_04.cd499bc3.png";